<template>
  <div>
    idexOf projets
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
